import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Header from "./header/Headers";
import "./styles.css";
import Analytics from "./Analytics/analytics";
import Home from "./Home/Home";
class App extends Component {
  componentDidMount() {}

  render() {
    return (
      <div className="container">
        <BrowserRouter>
          <div>
            <Header />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/analytics" component={Analytics} />
              {/* <Route path="/home" component={Home} /> */}
            </Switch>
          </div>
        </BrowserRouter>
        <div className="footer">
          Built by{" "}
          <a target="blank" href="http://similoluwaodeyemi.com">
            Similoluwa Odeyemi
          </a> © {new Date().getFullYear()}
          
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js